import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import CompactSearchBar from "./CompactSearchBar";
import Sidebar from "./Sidebar";

function Header({ showSearchBar = false, searchBarProps = {}, isResultPage = false, sidebarOpen: controlledSidebarOpen, setSidebarOpen: setControlledSidebarOpen }) {
  const navigate = useNavigate();
  const [internalSidebarOpen, setInternalSidebarOpen] = useState(false);

  const sidebarOpen = typeof controlledSidebarOpen === 'boolean' ? controlledSidebarOpen : internalSidebarOpen;
  const setSidebarOpen = typeof setControlledSidebarOpen === 'function' ? setControlledSidebarOpen : setInternalSidebarOpen;

  const sidebarItems = [
    { label: 'Flights', active: true },
    { label: 'Stays' },
    { label: 'Cars' },
    { label: 'Packages' },
    { label: 'KAYAK.ai', badge: 'BETA' },
    'divider',
    { label: 'Plan your trip' },
    { label: 'Explore' },
    { label: 'Flight Tracker' },
    { label: 'Travel tips' },
    'divider',
    { label: 'KAYAK for Business', badge: 'NEW' },
    { label: 'Trips' },
    { label: 'English' },
    { label: 'United States dollar' },
    { label: 'Feedback' },
  ];

  // Use the exact SVGs captured from the original Kayak sidebar (scaled to our container)
  const iconProps = (size, color) => ({ width: size, height: size, viewBox: "0 0 200 200", fill: color, xmlns: "http://www.w3.org/2000/svg", role: "presentation", "aria-hidden": "true" });

  const iconMap = {
    Flights: ({ color = '#7b8a92', size = 18 }) => (
      <svg {...iconProps(size, color)}>
        <path d="M178.081 41.973c-2.681 2.663-16.065 17.416-28.956 30.221c0 107.916 3.558 99.815-14.555 117.807l-14.358-60.402l-14.67-14.572c-38.873 38.606-33.015 8.711-33.015 45.669c.037 8.071-3.373 13.38-8.263 18.237L50.66 148.39l-30.751-13.513c10.094-10.017 15.609-8.207 39.488-8.207c8.127-16.666 18.173-23.81 26.033-31.62L70.79 80.509L10 66.269c17.153-17.039 6.638-13.895 118.396-13.895c12.96-12.873 26.882-27.703 29.574-30.377c7.745-7.692 28.017-14.357 31.205-11.191c3.187 3.166-3.349 23.474-11.094 31.167zm-13.674 42.469l-8.099 8.027v23.58c17.508-17.55 21.963-17.767 8.099-31.607zm-48.125-47.923c-13.678-13.652-12.642-10.828-32.152 8.57h23.625l8.527-8.57z"></path>
      </svg>
    ),
    Stays: ({ color = '#7b8a92', size = 18 }) => (
      <svg {...iconProps(size, color)}>
        <path d="M166.666 44.998v40.438h-6.078c-2.927-7.642-10.155-13.048-18.607-13.048H123.68c-8.452 0-15.68 5.406-18.607 13.048H94.927C92 77.794 84.772 72.388 76.32 72.388H58.019c-8.452 0-15.68 5.406-18.607 13.048H33.33V44.998h133.336zM180 113.749c0-10.387-7.445-18.982-17.131-20.414H37.131C27.44 94.767 20 103.362 20 113.749v41.253h13.33v-20.627h133.336v20.627H180v-41.253z"></path>
      </svg>
    ),
    Cars: ({ color = '#7b8a92', size = 18 }) => (
      <svg {...iconProps(size, color)}>
        <path d="M22.613 84.516C15.647 84.516 10 78.883 10 71.935h12.613c6.966 0 12.613 5.632 12.613 12.581H22.613zm154.774-12.581c-6.966 0-12.613 5.632-12.613 12.581h12.613c6.966 0 12.613-5.633 12.613-12.581h-12.613zm-14.97 13.387c17.991 23.752 15.201 5.722 15.201 74.678h-25.226v-15.484H46.638V160H22.382c0-61.366-3.522-57.158 15.26-75.027C52.259 31.161 56.599 40 127.818 40c25.287 0 29.864 27.733 34.599 45.322zM51.402 84.63h97.104c-10.46-38.739-5.871-32.049-76.037-32.049c-14.277 0-17.559 19.369-21.067 32.049zm9.619 26.983c0-6.948-5.647-12.581-12.613-12.581H35.796c0 6.948 5.647 12.581 12.613 12.581h12.612zm60.705 11.613H78.169a4.374 4.374 0 0 0-4.132 5.791c1.318 4.014 1.759 2.919 47.794 2.919c5.718-.001 5.891-8.71-.105-8.71zm42.479-24.194h-12.574c-6.944 0-12.613 5.655-12.613 12.581h12.574c6.944 0 12.613-5.654 12.613-12.581z"></path>
      </svg>
    ),
    Packages: ({ color = '#7b8a92', size = 18 }) => (
      <svg {...iconProps(size, color)}>
        <path d="M157.952 96.997c6.587-23.706 7.897-44.46 4.27-58.735c21.469 15.807 32.083 43.166 26.147 69.806l-30.417-11.071zm-33.65-71.949C98.32 24.07 73.444 38.069 61.141 61.761l29.201 10.628c10.043-22.067 22.168-38.629 33.96-47.341zM167.5 152.5h-64.222l24.267-66.571l22.224 8.089c7.814-28.622 6.856-50.857 1.101-61.029c-3.617-3.015-3.281-3.53-11.699-5.766c-11.068 2.509-27.356 19.292-40.644 48.145l17.85 6.497l-25.75 70.635H32.5C20.074 152.5 10 162.574 10 175h180c0-12.426-10.074-22.5-22.5-22.5z"></path>
      </svg>
    ),
    'KAYAK.ai': ({ color = '#7b8a92', size = 18 }) => (
      <svg {...iconProps(size, color)}>
        <path d="M 115.231 75.457 C 91.876 71.115 73.612 52.702 69.271 29.498 C 69.12 28.299 67.46 28.299 67.324 29.498 C 62.982 52.851 44.569 71.115 21.366 75.352 C 20.167 75.608 20.167 77.253 21.366 77.404 C 44.718 81.745 62.982 100.159 67.324 123.363 C 67.475 124.56 69.12 124.56 69.271 123.363 C 73.612 100.009 92.026 81.745 115.231 77.404 C 116.428 77.253 116.428 75.756 115.231 75.457 Z">
          <animate attributeName="opacity" values="1;0;1" keyTimes="0;0.5;1" dur="2s" begin="0.8s" repeatCount="indefinite" repeatDur="10s"></animate>
        </path>
        <path d="M 131.81 148.07 C 120.11 145.87 110.91 136.67 108.71 124.97 C 108.61 124.37 107.81 124.37 107.71 124.97 C 105.51 136.67 96.31 145.87 84.61 148.07 C 84.01 148.17 84.01 148.97 84.61 149.07 C 96.31 151.26 105.51 160.47 107.71 172.17 C 107.81 172.77 108.61 172.77 108.71 172.17 C 110.91 160.47 120.11 151.27 131.81 149.07 C 132.31 148.97 132.31 148.17 131.81 148.07 Z">
          <animate attributeName="opacity" values="1;0;1" keyTimes="0;0.5;1" dur="1.8s" begin="0s" repeatCount="indefinite" repeatDur="10s"></animate>
        </path>
        <path d="M 179.61 91.87 C 164.01 88.97 151.81 76.67 148.91 61.17 C 148.81 60.37 147.7 60.37 147.61 61.17 C 144.71 76.77 132.41 88.97 116.91 91.8 C 116.11 91.97 116.11 93.07 116.91 93.17 C 132.51 96.07 144.71 108.37 147.61 123.87 C 147.71 124.67 148.81 124.67 148.91 123.87 C 151.81 108.27 164.11 96.07 179.61 93.17 C 180.41 93.07 180.41 92.07 179.61 91.87 Z">
          <animate attributeName="opacity" values="1;0;1" keyTimes="0;0.5;1" dur="1.4s" begin="0.5s" repeatCount="indefinite" repeatDur="10s"></animate>
        </path>
      </svg>
    ),
    'Plan your trip': ({ color = '#7b8a92', size = 18 }) => (
      <svg {...iconProps(size, color)}>
        <path d="M178.81 126.07l-.08.08c-.5-.42-1.08-.92-1.58-1.33c-1-.75-1.91-1.5-2.91-2.16c-1.58-1-3.16-1.91-4.91-2.66c-.67-.25-1.33-.5-2-.75c-.17-.08-.42-.17-.58-.17c-1.25-.5-2.5-.92-3.83-1.25c-.67-.17-1.33-.33-2-.42c-2.16-.42-4.41-.67-6.66-.67c-20.64 0-37.46 16.81-37.46 37.46c0 2.25.25 4.49.67 6.66c.08.67.25 1.33.42 2c.33 1.5.83 3 1.41 4.41c.25.67.5 1.33.75 2c.75 1.66 1.66 3.33 2.66 4.91c.17.25.42.58.58.83c.5.75 1.08 1.41 1.58 2.08c.42.5.83 1.08 1.33 1.58c6.91 7.82 16.81 12.99 28.14 12.99c20.64 0 37.46-16.81 37.46-37.46c0-11.24-5.08-21.23-12.99-28.14zm-12.07 35.88l-5.08 4.99l-2.75 2.66c-2.5 2.5-5.83 3.75-9.07 3.75s-6.66-1.33-9.16-3.83l-11.4-11.57l11.74-11.74l8.91 8.99l16.81-16.65l.92-.92l11.74 11.74l-12.65 12.57zM125.08 30v7.5h-50V30c0-.25 0-.58.08-.83c.42-7 6.17-12.5 13.25-12.5h23.33c7.08 0 12.83 5.5 13.25 12.5c.08.25.08.58.08.83zm-20.67 145.17l.17.5l.25.42c-.17-.25-.33-.58-.42-.92zM166.74 42.5v59c-2.5-.67-5.17-1.08-7.83-1.25c-1.58-.08-3.08-.25-4.67-.25c-14.92 0-28.42 6.08-38.17 15.92c-9.92 9.75-16 23.33-16 38.25c0 1.75.08 3.42.33 5.17c.08 1.42.33 2.83.58 4.33c.08.58.25 1.25.42 1.92c0 .33.08.75.17 1.08c.25 1.17.58 2.25.92 3.33c.33 1.08.83 2.17 1.25 3.33l.25.83c.08.33.25.58.33.83l.08.17l.17.5l.25.42c.5 1 1 2.08 1.5 3.08c.75 1.33 1.42 2.58 2.25 3.92l.17.25H33.33V175l.08-132.5c0-7.33 6-13.33 13.33-13.33h11.75c-.08.25-.08.58-.08.83v24.17h83.33V30c0-.25 0-.58-.08-.83h11.75c7.33 0 13.33 6 13.33 13.33z"></path>
      </svg>
    ),
    Explore: ({ color = '#7b8a92', size = 18 }) => (
      <svg {...iconProps(size, color)}>
        <path d="M169.88 138.9h0a79.85 79.85 0 00-3.83-84c-.1-.15-.22-.29-.33-.44a79.91 79.91 0 00-131.3-.2c-.15.22-.33.43-.48.65c-1.37 2-2.63 4.07-3.82 6.2h0a79.85 79.85 0 003.83 84c.1.15.22.29.33.44a79.91 79.91 0 00131.3.2c.15-.22.33-.43.48-.65c1.37-2 2.63-4.1 3.82-6.2zM100 114.55a110.59 110.59 0 00-20.32 2a93.19 93.19 0 01-.05-33a111 111 0 0020.37 2a110.17 110.17 0 0020.37-2a96.15 96.15 0 011.45 16.45a98.18 98.18 0 01-1.5 16.52a111.13 111.13 0 00-20.32-1.97zm16.78 16.12a97.25 97.25 0 01-16.78 31a97.09 97.09 0 01-16.78-31a95.82 95.82 0 0116.78-1.58a98.8 98.8 0 0116.78 1.58zM83.17 69.32a101.72 101.72 0 0116.83-31a101.79 101.79 0 0116.83 31A95.33 95.33 0 01100 70.91a98.56 98.56 0 01-16.83-1.59zm51.35 10.6a115.45 115.45 0 0023.28-10.56a65.2 65.2 0 010 61.27a113 113 0 00-23.38-10.54a113.12 113.12 0 001.94-20.09a111.07 111.07 0 00-1.84-20.08zm15-22.59A100.53 100.53 0 01131 65.78a115.69 115.69 0 00-14.12-28.95a65.42 65.42 0 0132.64 20.5zm-66.39-20.5a115.75 115.75 0 00-14.08 28.85a98.56 98.56 0 01-18.56-8.37a65.51 65.51 0 0132.64-20.48zM65.49 79.88a107.94 107.94 0 00.07 40.17a115.19 115.19 0 00-23.36 10.59a65.2 65.2 0 010-61.27a113 113 0 0023.29 10.51zm-15 62.79a100.14 100.14 0 0118.61-8.47a112.19 112.19 0 0014 29a65.4 65.4 0 01-32.62-20.53zm66.46 20.48a112.49 112.49 0 0013.94-28.85a98.23 98.23 0 0118.63 8.39a65.45 65.45 0 01-32.58 20.46z"></path>
      </svg>
    ),
    'Flight Tracker': ({ color = '#7b8a92', size = 18 }) => (
      <svg {...iconProps(size, color)}>
        <path d="M168.281 58.293c6.845-11.994-5.4-26.252-18.407-20.847C98.458-3.603 20 32.035 20 100c0 44.183 35.817 80 80 80c62.669 0 100.636-68.852 68.281-121.707zm-63.17-27.232a68.554 68.554 0 0 1 37.055 14.07c-4.703 11.218 5.608 23.149 17.509 19.833a68.481 68.481 0 0 1 9.264 29.925h-21.63c-2.285-22.237-19.961-39.913-42.199-42.199V31.061zm0 32.809c16.099 2.175 28.844 14.92 31.019 31.019h-25.588a11.472 11.472 0 0 0-5.431-5.431V63.87zm5.241 41.004h25.588c-2.498 18.488-18.934 32.552-38.383 31.265c-43.199-2.859-45.502-66.262-2.432-72.08v25.588a11.44 11.44 0 0 0-6.384 12.184c1.723 10.959 16.792 13.189 21.611 3.043zm-12.759 63.959c-35.94-1.236-65.19-30.486-66.426-66.426c-1.29-37.5 27.4-68.589 63.958-71.157v21.63c-24.355 2.503-43.239 23.467-42.424 48.667c.801 24.759 20.992 44.951 45.751 45.751c25.199.815 46.164-18.068 48.667-42.424h21.63c-2.567 36.559-33.656 65.248-71.156 63.959z"></path>
      </svg>
    ),
    'Travel tips': ({ color = '#7b8a92', size = 18 }) => (
      <svg {...iconProps(size, color)}>
        <path d="M172.73 56.36H27.27A7.27 7.27 0 0120 49.09v-7.27a7.27 7.27 0 017.27-7.27h145.46a7.27 7.27 0 017.27 7.27v7.27a7.27 7.27 0 01-7.27 7.27zM180 158.18v-7.27a7.27 7.27 0 00-7.27-7.27h-58.18a7.27 7.27 0 00-7.27 7.27v7.27a7.27 7.27 0 007.27 7.27h58.18a7.27 7.27 0 007.27-7.27zm0-36.36v-7.27a7.27 7.27 0 00-7.27-7.27h-58.18a7.27 7.27 0 00-7.27 7.27v7.27a7.27 7.27 0 007.27 7.27h58.18a7.27 7.27 0 007.27-7.27zm-87.27 36.36v-80a7.27 7.27 0 00-7.27-7.27H27.27A7.27 7.27 0 0020 78.18v80a7.27 7.27 0 007.27 7.27h58.18a7.27 7.27 0 007.27-7.27h0zM180 85.45v-7.27a7.27 7.27 0 00-7.27-7.27h-58.18a7.27 7.27 0 00-7.27 7.27v7.27a7.27 7.27 0 007.27 7.27h58.18a7.27 7.27 0 007.27-7.27z"></path>
      </svg>
    ),
    'KAYAK for Business': ({ color = '#7b8a92', size = 18 }) => (
      <svg {...iconProps(size, color)}>
        <path d="M78.182 42h43.636v14.5h14.546V41.855c0-7.924-6.451-14.355-14.407-14.355H78.044c-7.956 0-14.407 6.431-14.407 14.355V56.5h14.546V42zM20 63.75V158c0 8.004 6.516 14.5 14.545 14.5h130.909c8.029 0 14.545-6.496 14.545-14.5V63.75H20z"></path>
      </svg>
    ),
    Trips: ({ color = '#7b8a92', size = 18 }) => (
      <svg {...iconProps(size, color)}>
        <path d="M176.54 34.58c-8.61-8.83-20.13-13.99-32.29-14.53c-21.53-.97-36.06 12.06-43.92 22.17c-7.86-10.12-22.39-23.14-43.92-22.17c-12.27.54-23.68 5.7-32.29 14.53c-8.72 8.93-13.45 20.56-13.45 32.83c0 19.27 10.98 41.01 32.51 64.58c17.11 18.73 32.29 33.15 46.28 44.24c3.23 2.48 7.1 3.77 10.87 3.77s7.64-1.29 10.87-3.77c14.1-11.09 29.17-25.51 46.28-44.24c21.53-23.57 32.51-45.32 32.51-64.58c0-12.27-4.74-23.9-13.46-32.83z"></path>
      </svg>
    ),
    'English': ({ color = '#7b8a92', size = 18 }) => (
      <img
        src="https://www.kayak.com/res/images/flags-svg/us.svg"
        alt="United States (English)"
        width={18}
        height={12}
        style={{ display: 'block', border: '1px solid #dfe6ea', borderRadius: 2 }}
      />
    ),
    'United States dollar': ({ color = '#7b8a92', size = 18 }) => (
      <svg {...iconProps(size, color)}>
        <text x="50%" y="55%" dominantBaseline="middle" textAnchor="middle" fontSize="120" fill={color}>$</text>
      </svg>
    ),
    Feedback: ({ color = '#7b8a92', size = 18 }) => (
      <svg {...iconProps(size, color)}>
        <path d="M163.83 30.34H36.37a16.15 16.15 0 00-16 16v95.19a16 16 0 0016.2 15.97l23.6-.2l18.62 32.36L97.61 157h66.12a16 16 0 0015.93-15.93v-94.9a15.81 15.81 0 00-15.83-15.83zM58.28 131.81l5.48-22.91l50.68-49.58l16 15.63c-59.91 58.65-43.58 47.3-72.16 56.86zm80.15-64.63c-3.58 3.49.3 5.48-18.71-13l2.68-2.59c10.66-10.39 26.6 5.24 16.03 15.59z"></path>
      </svg>
    ),
  };

  return (
    <>
    <header
      onClick={() => {
        if (sidebarOpen) setSidebarOpen(false);
      }}
      style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "0.5rem 0.8rem 0.5rem 0.8rem",
      background: "#fff",
      boxShadow: "0 1px 0 #eee",
      minHeight: 64,
      position: 'sticky',
      top: 0,
      zIndex: isResultPage ? 100 : 10000,
    }}
    >
      {/* Left: Logo and menu */}
      <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
        <button
          style={{ background: "none", border: "none", padding: 0, marginRight: 16, cursor: "pointer", width: 32, height: 32, display: "flex", alignItems: "center", justifyContent: "center" }}
          aria-label="Open menu"
          onClick={(e) => {
            e.stopPropagation();
            setSidebarOpen(!sidebarOpen);
          }}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect y="5" width="24" height="2" rx="1" fill="#111" />
            <rect y="11" width="24" height="2" rx="1" fill="#111" />
            <rect y="17" width="24" height="2" rx="1" fill="#111" />
          </svg>
        </button>
        <button
          style={{ width: 125, height: 24, background: 'none', border: 'none', padding: 0, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          aria-label="Go to landing page"
          onClick={(e) => { e.stopPropagation(); navigate('/'); }}
        >
          <svg width="100%" height="100%" viewBox="0 0 125 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="presentation" style={{ width: "inherit", height: "inherit", lineHeight: "inherit", color: "inherit" }}><path fillRule="evenodd" clipRule="evenodd" d="M0 24h23.936V0H0v24zm25.266 0h23.936V0H25.266v24zm49.202 0H50.532V0h23.936v24zm1.33 0h23.936V0H75.798v24zM125 24h-23.936V0H125v24z" fill="#FF690F"></path><path fillRule="evenodd" clipRule="evenodd" d="M10.287 11.549V6H7.38v12h2.907v-5.548L13.348 18h3.208l-3.33-6 3.33-6h-3.208l-3.061 5.549zm24.785 4.724L34.552 18h-3.104l3.947-12h3.696l3.93 12h-3.194l-.52-1.727h-4.235zm2.117-6.837l-1.4 4.48h2.8l-1.4-4.48zM63.98 18h-2.906v-5.29L57.144 6h3.463l1.938 3.688L64.447 6h3.409l-3.876 6.71V18zm21.624-1.727L85.084 18h-3.105l3.948-12h3.696l3.93 12h-3.194l-.52-1.727h-4.235zm2.117-6.837l-1.4 4.48h2.8l-1.4-4.48zm23.63 2.113V6h-2.907v12h2.907v-5.548L114.412 18h3.208l-3.33-6 3.33-6h-3.208l-3.061 5.549z" fill="#FAFAFC"></path></svg>
        </button>
      </div>
      
      {/* Center: Compact Search Bar */}
      {showSearchBar && (
        <div
          onMouseDownCapture={() => { if (sidebarOpen) setSidebarOpen(false); }}
          style={{ 
          flex: 1, 
          display: "flex", 
          justifyContent: "center", 
          alignItems: "center", 
          minWidth: 0, 
          margin: "0 64px",
        }}>
          <CompactSearchBar
            {...searchBarProps}
            onSwap={(swappedData) => {
              // Handle swap functionality - pass to parent callback if provided
              if (searchBarProps.onSwap) {
                searchBarProps.onSwap(swappedData);
              }
              console.log("Swapped:", swappedData);
            }}
            onFieldClick={(field) => {
              // Handle field click - pass to parent callback if provided
              if (searchBarProps.onFieldClick) {
                searchBarProps.onFieldClick(field);
              }
              console.log("Field clicked:", field);
            }}
            onSubmit={(data) => {
              // Handle submit - pass to parent callback if provided
              if (searchBarProps.onSubmit) {
                searchBarProps.onSubmit(data);
              }
              console.log("Submit:", data);
            }}
            isResultPage={searchBarProps.isResultPage}
          />
        </div>
      )}
      
      {/* Right: Favorite and Sign in */}
      <div style={{ display: "flex", alignItems: "center", gap: 24, marginLeft: 16 }}>
        <button style={{ background: "none", border: "none", cursor: "pointer", padding: 0, display: "flex", alignItems: "center", justifyContent: "center" }} aria-label="Favorites">
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14 25s-8.5-6.7-8.5-12.1C5.5 8.1 8.4 5 12 5c1.7 0 3.3.8 4 2.1C16.7 5.8 18.3 5 20 5c3.6 0 6.5 3.1 6.5 7.9C22.5 18.3 14 25 14 25z" fill="#181A1B" />
          </svg>
        </button>
        <button
          aria-label="Sign in"
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            background: "rgb(255, 255, 255)",
            color: "rgb(15, 20, 26)",
            border: "1px solid rgb(0, 0, 0)",
            borderRadius: 12,
            padding: "10px 14px",
            height: 36,
            cursor: "pointer",
            boxShadow: "rgba(0, 0, 0, 0) 0px 0px 0px 0px",
            fontWeight: 700,
            fontSize: 14,
            lineHeight: 1,
            transition: "border-color 120ms, box-shadow 120ms",
          }}
        >
          <svg viewBox="0 0 200 200" width="1.25em" height="1.25em" xmlns="http://www.w3.org/2000/svg" role="presentation" aria-hidden="true">
            <path fill="currentColor" d="M118.61 188.05c.7-.15 1.36-.36 2.05-.53c2.32-.55 4.62-1.13 6.87-1.85c.51-.17 1-.38 1.51-.55c2.4-.82 4.77-1.7 7.08-2.72c.31-.14.6-.3.91-.44c2.48-1.12 4.91-2.34 7.26-3.67c.14-.08.26-.16.4-.24c2.51-1.44 4.94-2.99 7.28-4.66c.01 0 .03-.02.04-.03C174.97 157.05 190 130.3 190 100c0-49.71-40.29-90-90-90s-90 40.29-90 90c0 30.31 15.03 57.06 37.99 73.36c.01 0 .03.02.04.03c2.35 1.67 4.78 3.22 7.28 4.66c.14.08.26.17.4.24c2.36 1.34 4.79 2.55 7.27 3.68c.31.14.6.3.9.43c2.31 1.01 4.68 1.9 7.08 2.72c.51.17 1 .39 1.51.55c2.25.72 4.55 1.3 6.87 1.85c.69.16 1.35.38 2.05.53c2.28.48 4.61.81 6.95 1.11c.75.1 1.48.26 2.24.34c3.1.32 6.23.5 9.42.5s6.32-.17 9.42-.5c.76-.08 1.49-.24 2.24-.34c2.34-.3 4.67-.63 6.95-1.11zM100 26.36c40.6 0 73.64 33.03 73.64 73.64c0 19.08-7.35 36.43-19.3 49.52c-14.45-12.93-33.42-20.88-54.34-20.88s-39.89 7.95-54.34 20.88c-11.94-13.09-19.3-30.44-19.3-49.52c0-40.6 33.03-73.64 73.64-73.64zM75.45 91.81V71.36c0-1.39.12-2.76.34-4.09C77.74 55.66 87.83 46.82 100 46.82c13.56 0 24.55 10.99 24.55 24.55v20.45c0 13.56-10.99 24.55-24.55 24.55s-24.55-10.99-24.55-24.55z"></path>
          </svg>
          <span>Sign in</span>
        </button>
      </div>
    </header>
    <Sidebar
      open={sidebarOpen}
      onClose={() => setSidebarOpen(false)}
      sidebarItems={sidebarItems}
      iconMap={iconMap}
      headerOffset={80}
      collapsedWhenClosed={isResultPage}
    />
    </>
  );
}

export default Header; 